import cssClasses from '../helpers/cssClasses';
import {setCookie, getCookie} from '../helpers/cookies';

/**
 * Export default Location
 */
export default () => {

  const selectors = {
    modal: document.querySelector('.c-country'),
    close: document.querySelectorAll('.c-country__link'),
  };

  function searchCountry() {
    if (typeof geoip2 !== 'undefined') {
      geoip2.country(geolocation);
    } else {
      console.log(`🗺️ Location: No GEOIP 🛑`);
    }
  }

  function geolocation(geoipResponse) {
    checkRedirect(geoipResponse.country.iso_code || 'blank');
  };


  function checkRedirect(geoCountry) {
    if (theme.features.location == geoCountry) {
      setCookie('Karmoon_Location', geoCountry, 300);
      return;
    } else {
      const name = 'no_redirect'
      const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

      if (results === null) {
          selectors.modal.classList.add(cssClasses.active);
      } else {
        setCookie('Karmoon_Location', 'is-closed', 300);
      }
    }
  }

  function close() {
    selectors.close.forEach((item) => {
      item.addEventListener('click', function (evt){
        evt.preventDefault();
        const target = evt.target;
        const newTarget = `${target.getAttribute("href")}?no_redirect=true`;

        selectors.modal.classList.add(cssClasses.hidden);
        setCookie('Karmoon_Location', 'is-closed', 300);
        window.location.assign(newTarget)
      });
    });
  }

  function init() {
    console.log(`🗺️ Location: Loaded`);
    const CC = document.getElementById('c-country');
    if (CC) {
      checkCookie();
    }
  }

  function checkCookie() {
    const hasBeenSet = getCookie('Karmoon_Location');

    if(hasBeenSet) {
      return;
    } else {
      searchCountry();
      close();
    }
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
